$(window).load(function () {
    if ($('tr.cart__row').length) {
        $('tr.cart__row').each(function (i, v) {
            let cart_item_url = $(v).attr('data-cart-item-url').split('?')
            let variant = cart_item_url[1].split('=')
            let id_variant = variant[1]

            $(v).find(".btn-subtract").attr('variant-id', id_variant)
            $(v).find(".btn-add").attr('variant-id', id_variant)
        })
    }

    if ($(".input-group-qty").length) {
        const minimum = 0;

        $(document).on("click", ".btn-subtract", function () {
            let key = $(this).attr("data-key")
            let variant_id = $(this).attr("variant-id")
            var quantity = $(this).next().val() * 1;

            if (quantity <= minimum) {
                return; // return to avoid decrementing
            } else {
                // minus.disabled = false;
                $(this).next().val(quantity - 1)
            }

            updateQtyAjax(key, variant_id, quantity - 1)
            // $('form.cart').trigger('submit')
        })

        $(document).on("click", ".btn-add", function () {
            let key = $(this).attr("data-key")
            let variant_id = $(this).attr("variant-id")

            var quantity = $(this).prev().val() * 1;
            $(this).prev().val(quantity + 1)

            updateQtyAjax(key, variant_id, quantity + 1)
            // $('form.cart').trigger('submit')
        });

    }

    function updateQtyAjax(line_item_key, variant_id, qty) {
        jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                'id': variant_id,
                'quantity': qty
            },
            success: function (response) {
                console.log(response)
                if (response.items.length == 0 && qty == 0) {
                    $('div[data-cart-wrapper]').addClass('hide')
                    $('.empty-page-content').removeClass('hide')
                }
                else if (qty == 0) {
                    $(`tr[data-cart-item-key="${line_item_key}"]`).remove()
                }
                else {
                    $.each(response.items, function (i, v) {
                        // console.log('v', v.key, line_item_key, v.key == line_item_key)
                        if (v.key == line_item_key) {
                            $(`tr[data-cart-item-key="${line_item_key}"]`).find('span[data-cart-item-regular-price]').html(currencyFormat(v.final_line_price / 100))
                        }
                    })
                }

                $('span[data-cart-subtotal]').html(currencyFormat(response.items_subtotal_price / 100))
            },
            error: function (response) {
                console.log(response);
            },
        })
    }

    function currencyFormat(num) {
        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            maximumFractionDigits: 0,
        }).format(num);
    }
});